'use client'
import { Link } from "react-router-dom";
import { useState, useEffect } from 'react'
import { Dialog, DialogBackdrop } from '@headlessui/react'
//img
import BackVideo from './img/back-video-proces.png';
import { XMarkIcon } from '@heroicons/react/24/outline'

//page
import Nav from './Nav';

export function useIsVisible(ref) {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIntersecting(entry.isIntersecting)
        }
        );

        observer.observe(ref.current);
        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return isIntersecting;
}

export default function Example() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <div className="bg-[url('img/back-proces.png')] bg-top bg-cover">
                <Nav />

                <div className="relative isolate px-6 pt-14 lg:px-8">

                    <div className="mx-auto max-w-7xl py-16 sm:py-32">
                        <div className="text-left">
                            <h1 className="titre">
                                Une oeuvre peut-elle contribuer à la culture <br />du viol ?
                            </h1>
                            {/**video  */}
                            <div className='mt-10 w-full'>
                                <button onClick={() => setOpen(true)} class="w-full relative flex justify-center items-center focus:outline-none focus-visible:ring focus-visible:ring-indigo-300 rounded-3xl group" aria-controls="modal" aria-label="Watch the video">
                                    <img class="w-full rounded-3xl shadow-2xl transition-shadow duration-300 ease-in-out" src={BackVideo} width="100%" height="auto" alt="Notre proces" />

                                    <svg class="absolute pointer-events-none group-hover:scale-110 transition-transform duration-300 ease-in-out" xmlns="http://www.w3.org/2000/svg" width="72" height="72">
                                        <circle class="fill-white" cx="36" cy="36" r="36" fill-opacity=".8" />
                                        <path class="fill-indigo-500 drop-shadow-2xl" d="M44 36a.999.999 0 0 0-.427-.82l-10-7A1 1 0 0 0 32 29V43a.999.999 0 0 0 1.573.82l10-7A.995.995 0 0 0 44 36V36c0 .001 0 .001 0 0Z" />
                                    </svg>
                                </button>
                            </div>
                            {/** explication */}
                            <div className='mt-28'>
                                <h2 className='ss-titre'>Un procès fictif d’après <br />une controverse réelle</h2>
                                <p className='mt-10 text-[18px] leading-[2rem] text-white'>
                                    En 2017, Madame Gaber était candidate au concours de l’agrégation de lettres. Une des oeuvres au programme était celle d’André Chénier, et notamment son poème “l’Oaristys”.
                                    <br /><br />
                                    Le 3 novembre 2017, Madame Gaber a co-écrit une lettre ouverte au jury du concours pour demander une clarification de la qualification attendue de la scène de ce poème. En effet, son collectif le percevait non pas comme une scène de séduction, mais comme une scène de viol. Cette lettre a déclenché une controverse dans le monde académique, qui a pris de l’ampleur du fait notamment de sa diffusion sur les réseaux sociaux.
                                    <br /><br />
                                    Le 25 novembre 2023, à l’occasion de la journée internationale de la lutte contre les violences faites aux femmes, Madame Gaber a diffusé, le hashtag <i>#cheniercultureduviol</i>, qui est rapidement devenu viral.
                                    <br /> Monsieur André Chénier a alors été pris à partie sur twitter, instagram et Facebook, où ont été publiés des milliers de messages anonymes à caractère injurieux.
                                    <br /><br />
                                    Le 1er décembre 2023, Monsieur André Chénier a déposé une plainte en diffamation avec constitution de partie civile auprès du Procureur de la République.
                                </p>
                            </div>

                            {/** question */}
                            <div className='mt-28'>
                                <h2 className="titre">
                                    Madame Gaber doit-elle<br /> être condamnée pour<br /> diffamation ?
                                </h2>
                                <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 mt-10'>
                                    {/** card */}
                                    <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch text-white min-h-52'>
                                        <p className='text-[80px] font-bold mb-16'>2%</p>
                                        <p className='text-[40px] font-bold'>la reconnaissent coupable</p>
                                    </div>
                                    {/** card */}
                                    <div className='p-6 rounded-lg bg-[#D9D9D9] flex flex-col items-stretch text-black min-h-52'>
                                        <p className='text-[80px] font-bold mb-16'>98%</p>
                                        <p className='text-[40px] font-bold'>la reconnaissent coupable mais excusée</p>
                                        <p className='text-[14px] font-normal'>78% au titre de l’excuse de vérité / 22% au titre de l'excuse de bonne foi</p>
                                    </div>
                                </div>
                                <div className='flex flex-col mt-6 text-center justify-center'>
                                    <Link to="/devenez-jure"
                                        type="button"
                                        className="mx-auto rounded-full bg-[#9A0A6B] px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-white hover:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                    >
                                        Devenez juré(e)
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/** video frame dialog */}
            <Dialog open={open} onClose={setOpen} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen">
                    <div className="flex bg-purple-800 items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <div className="absolute right-0 top-0 pr-4 pt-4 sm:block">
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                className="rounded-md text-white hover:text-gray-500 focus:outline-none focus:ring-2 ring-indigo-500 focus:ring-offset-2"
                            >
                                <span className="sr-only">Close</span>
                                <XMarkIcon aria-hidden="true" className="size-6" />
                            </button>
                        </div>

                        <div className="mt-6 text-center w-screen p-6 relative min-h-screen">
                       <iframe style={{ position: 'absolute', top: 20, left: 20, width: '100%', height: '80%' }} src="https://player.vimeo.com/video/1048855623?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" title="Notre proces - Trailer long"></iframe><script src="https://player.vimeo.com/api/player.js"></script>
                        </div>

                    </div>
                </div>
            </Dialog>

        </>
    )
}
